import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

import AsyncAdmin from "./LazyAdmin";

const ADMIN = document.location.pathname.match('^/admin');

ReactDOM.render(ADMIN ? <AsyncAdmin /> : <App />, document.getElementById('es-main-app'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
